export default {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SunGod',
  legalName: 'SunGod Ltd',
  url: 'https://www.sungod.co',
  logo: 'https://static.sungod.co/images/email/em_logo2.jpg',
  foundingDate: '2013-09-13',
  founders: [
    {
      '@type': 'Person',
      name: 'Ali Watkiss'
    },
    {
      '@type': 'Person',
      name: 'Zoe Watkiss'
    }],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    email: 'support@sungod.co'
  },
  sameAs: [
    'https://www.facebook.com/sungodsunglasses',
    'https://twitter.com/we_are_sungod',
    'https://www.youtube.com/sungod',
    'https://www.instagram.com/we_are_sungod',
    'https://www.strava.com/clubs/sungod'
  ]
}
